<template>
    <div id="faq-view" :class="mode == 'dark' ? 'dark' : 'light'">
        <div class="uk-section uk-section-large uk-padding">

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>What is Harvest?</h2>
                </div>
                <div class="uk-card-body">
                    <h3>Harvest automatically farms the highest yield available from the newest DeFi protocols, and optimizes the yields that are received using the latest farming techniques.</h3>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>What is FARM?</h2>
                </div>
                <div class="uk-card-body">
                    <h3>FARM is a cashflow token for Harvest, one of the largest autonomous hedge funds.</h3>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>What are the token economics for FARM?</h2>
                </div>
                <div class="uk-card-body">
                    <ul class="uk-list uk-list-bullet">
                        <li>Farm holders receive cashflows from revenues on AUM, currently set to 30% profit sharing</li>
                        <li>Circulating supply at launch: 0</li>
                        <li>FARM has a current circulating supply of 245,031.694</li>
                        <li>FARM has a total supply over 4 years of 690,420</li>
                        <li>14,850 FARM has been burned in week 3</li>
                        <li>5,846.9 FARM has been burned in week 4</li>
                        <li>Harvest was completely bootstrapped, with no VCs and no premine</li>
                    </ul>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>What is fDAI, fUSDC, fWBTC?</h2>
                </div>
                <div class="uk-card-body">
                    <h3>fDAI, fUSDC, fWBTC are the yield-bearing versions of these assets, which are being automatically farmed by the harvest algorithm.
                        These assets are automatically appreciating, and you can redeem them at any time for DAI, USDC, wBTC.</h3>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>What was the reason for launching Harvest?</h2>
                </div>
                <div class="uk-card-body">
                    <ul class="uk-list uk-list-bullet">
                        <li>We were looking for a convenient way to farm the latest projects that were producing different reward tokens. The process was highly manual and inconvenient for people that had a normal job and didn’t want to keep up with DeFi 24/7.</li>
                        <li>Gas prices have been really high, and it was expensive to farm by ourselves, so we pooled our funds together to try to save on gas. We decided to build the solution that we were looking for ourselves, and hopefully will help many others.</li>
                    </ul>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>What is the road map for Harvest?</h2>
                </div>
                <div class="uk-card-body">
                    <ul class="uk-list uk-list-bullet">
                        <li>Yield farming is not going away, and gas prices are not getting lower. Our goal is to simply provide an easy way for people to benefit, and make your hard work much easier, while looking for safe projects to add to the farming repertoire.</li>
                        <li>We plan to add more assets over time. DAO funds can be used to add useful integrations, provide bug bounties and pay for security audits, and even fund projects to build on top of Harvest and add value to FARM holders.</li>
                    </ul>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>Smart contracts and audits</h2>
                </div>
                <div class="uk-card-body">
                    <ul class="uk-list uk-list-bullet">
                        <li>The Harvest smart contracts are <a href="https://github.com/harvest-finance" target="_blank">here</a>.</li>
                        <li>The Harvest smart contracts have been designed from the ground up with security in mind, by using as many audited components as possible. Please review the smart contracts before depositing funds.</li>
                        <li>Harvest's audit reports are <a href="https://github.com/harvest-finance/harvest/tree/master/audits" target="_blank">here</a>.</li>
                        <li>We would like to thank Haechi and Peckshield for their hard work on this audit and keeping our farmers safe.</li>                  
                    </ul>
                    <div class="uk-flex uk-flex-around image-holder">
                        <a href="https://haechi.io/" target="_blank"><img src="@/assets/audits/haechi.png" alt="Haechi"></a>
                        <a href="https://peckshield.com/en" target="_blank"><img src="@/assets/audits/peck.png" alt="PeckShield"></a>
                    </div>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>Acknowledgements</h2>
                </div>
                <div class="uk-card-body">
                    <h3>Thanks to:</h3>
                    <ul class="uk-list uk-list-bullet">
                        <li>The many people who helped out with this project, including providing comments and helpful suggestions for the early iterations of this product.</li>
                        <li>Weeb who has created one of the most useful public goods at <a href="https://yieldfarming.info/" target="_blank">https://yieldfarming.info/</a>.</li>
                        <li>Andre Cronje, who provided inspiration in that a lone developer can build so much useful DeFi infrastructure so quickly. He’s a great example of what is possible in the world of DeFi where barriers to entry have been greatly reduced, and software, creativity, and value are so closely interlinked.</li>
                        <li>The community for participating in this farming cooperative with us, thank you!</li>                  
                    </ul>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>Where can I learn more about Harvest?</h2>
                </div>
                <div class="uk-card-body">
                    <h3>👩‍🌾 The Harvest Community Wiki has a wealth of up-to-date information <a href="https://farm.chainwiki.dev/" target="_blank">https://farm.chainwiki.dev/</a></h3>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>Links</h2>
                </div>
                <div class="uk-card-body">
                    <ul class="uk-list uk-list-bullet">
                        <li><a href="https://harvest.finance/breadtothepeople">🧑‍🌾Inactive Pools</a></li>
                        <li><a href="https://github.com/harvest-finance">GitHub</a></li>
                        <li><a href="https://twitter.com/harvest_finance">Twitter</a></li>
                        <li><a href="https://discord.gg/R5SeTVR">Discord</a></li>
                        <li><a href="https://medium.com/harvest-finance">Medium</a></li>
                        <li><a href="https://www.reddit.com/r/HarvestFinance/">Reddit</a></li>
                        <li><a href="https://farm.chainwiki.dev/">Wiki</a></li>
                        <li><a href="https://farm.chainwiki.dev/zh/%E7%AD%96%E7%95%A5">策略</a></li>
                        <li><a href="https://harvestfi.github.io/dashboard/">Dashboard</a></li>
                        <li><a href="https://github.com/harvest-finance/harvest/tree/master/audits">Audits</a></li>                  
                    </ul>
                </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">
                <div class="uk-card-header">
                    <h2>Harvest is proud to be listed on:</h2>
                </div>
                <div class="uk-card-body">
                    <div class="uk-flex uk-flex-around image-holder">
                        <a href="https://defipulse.com/" target="_blank"><img src="@/assets/listed/defi-pulse.png" alt="Defi-Pulse"></a>
                        <a href="https://debank.com/" target="_blank"><img src="@/assets/listed/debank.svg" alt="Debank"></a>
                        <a href="https://defiprime.com/derivatives" target="_blank"><img src="@/assets/listed/defiprime.png" alt="Defiprime"></a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "FAQ",
    props: {
        mode: String
    }
}
</script>

<style lang="less" scoped>
    @import "../dark-components/faq.less";

    .uk-card {
        h2 {
            font-family: 'Lato';
            font-weight: 700;
            .fluid-font(1.2, 25, 320, 3840);
            color: @text-color;
        }

        h3 {
            font-family: 'Lato';
            .fluid-font(1, 15, 320, 3840);
            color: @text-color;
        }

        ul.uk-list li {
            font-family: 'Lato';
            .fluid-font(1, 15, 320, 3840);
            color: @text-color;

            a {
                color: @link-color;
            }
        }

        img {
            height: 64px
        }

        box-shadow: 5px 5px 0 @brand-color;
        border: 2px @brand-color solid;
    }

    @media only screen and (max-width: 640px) {
        .image-holder {
            img {
                height: auto;
                width: 80%;
                margin-bottom: .5em;
            }
            flex-direction: column;
        }
    }
</style>